/* src/app/contract-structure/presenters/contract-structure-presenters.component.scss */
.contract-structure-tree .p-treetable {
  font-size: 12px !important;
}
.contract-structure-tree .p-treetable .p-treetable-thead > tr > th {
  background: #45454b !important;
  color: #ffffff !important;
  padding: 0.5rem !important;
  border-right: 1px dotted var(--p-content-border-color, #d1d5db) !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.contract-structure-tree .p-treetable .p-treetable-tbody > tr > td {
  padding: 0.25rem !important;
  border-right: 1px dotted var(--p-content-border-color, #d1d5db) !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: visible !important;
}
.contract-structure-tree .p-treetable .p-treetable-thead > tr > th:last-child,
.contract-structure-tree .p-treetable .p-treetable-tbody > tr > td:last-child {
  border-right: none !important;
}
.contract-structure-tree .p-treetable .p-select {
  width: 100% !important;
}
.contract-structure-tree .p-treetable .p-treetable-tbody > tr > td .p-treetable-toggler {
  padding: 0;
}
.contract-structure-tree .contract-structure-tree-toggler-icon {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  background: var(--p-surface-100, #45454b);
  color: var(--p-primary-500, #000000);
  border: 1px solid var(--p-content-border-color, #9ca3af);
  border-radius: 2px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: var(--p-text-muted-color, #6b7280);
}
.contract-structure-tree .boolean-check-cell {
  text-align: center !important;
  vertical-align: middle !important;
}
.contract-structure-tree .contract-structure-boolean-check {
  font-size: 1.75rem;
  line-height: 1;
  width: 1.75rem;
  height: 1.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
.contract-structure-tree .clickable-cell {
  cursor: pointer;
}
.contract-structure-tree .disabled {
  opacity: 0.6;
  pointer-events: none;
}
.contract-structure-tree .status-icon {
  font-size: 20px;
  line-height: 20px;
}
.contract-structure-tree .green {
  color: #4caf50;
}
.contract-structure-tree .yellow {
  color: #fbc02d;
}
.contract-structure-tree .red {
  color: #f44336;
}
/*# sourceMappingURL=contract-structure-presenters.component.css.map */
